import { render, staticRenderFns } from "./safOpinionBoardDetailOuter.vue?vue&type=template&id=101eca26"
import script from "./safOpinionBoardDetailOuter.vue?vue&type=script&lang=js"
export * from "./safOpinionBoardDetailOuter.vue?vue&type=script&lang=js"
import style0 from "./safOpinionBoardDetailOuter.vue?vue&type=style&index=0&id=101eca26&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101eca26')) {
      api.createRecord('101eca26', component.options)
    } else {
      api.reload('101eca26', component.options)
    }
    module.hot.accept("./safOpinionBoardDetailOuter.vue?vue&type=template&id=101eca26", function () {
      api.rerender('101eca26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/outer/safOpinionBoardDetailOuter.vue"
export default component.exports